import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/auth';
import api from '../utils/api';
import Loader from './Loader';
import { canAccessPage, homePathForUser } from '../utils/workspace';

/** Redirects when the signed-in user lacks the given sidebar page-key. */
export default function RequirePageAccess({ pageKey, variant = 'admin', children }) {
    const user = useAuth(s => s.user);
    const [roleDoc, setRoleDoc] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!user?.role) {
            setRoleDoc(null);
            setReady(true);
            return;
        }
        let cancelled = false;
        setReady(false);
        api.get('/roles').then(r => {
            if (cancelled) return;
            setRoleDoc((r.data.items || []).find(x => x.slug === user.role) || null);
            setReady(true);
        }).catch(() => {
            if (!cancelled) setReady(true);
        });
        return () => { cancelled = true; };
    }, [user?.role, (user?.permissions || []).join('|')]);

    if (!user) return <Loader />;
    if (!ready) return <Loader />;
    if (!canAccessPage(user, roleDoc, pageKey)) {
        return <Navigate to={homePathForUser(user, roleDoc)} replace />;
    }
    return children;
}
